import { useQuery } from "@tanstack/react-query";
import { categoryService } from "../services/category.service";
import { CategoryType, CategoryStatus } from "../domain/category.interface";

// Re-export types for convenience
export { CategoryType, CategoryStatus };

/**
 * Hook to fetch category by type
 */
export const useCategoryByType = (type: CategoryType, enabled = true) => {
	return useQuery({
		queryKey: ["category", "type", type],
		queryFn: () => categoryService.getCategoryByType(type),
		enabled: enabled && !!type,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
};

/**
 * Hook to fetch tampered reasons category
 * Convenience hook for the common use case
 */
export const useTamperedReasons = (enabled = true) => {
	return useCategoryByType(CategoryType.TAMPERED_REASON, enabled);
};

/**
 * SIMS-8634 — the payer categories.
 */
export const usePayerCategories = (enabled = true) => {
	return useCategoryByType(CategoryType.PAYER_CATEGORY, enabled);
};

/**
 * Hook to fetch category by ID
 */
export const useCategoryById = (id: string) => {
	return useQuery({
		queryKey: ["category", id],
		queryFn: () => categoryService.getCategoryById(id),
		enabled: !!id,
		staleTime: 5 * 60 * 1000,
	});
};
